import { render, staticRenderFns } from "./FinancialPlanShare.vue?vue&type=template&id=0accf141&scoped=true"
import script from "./FinancialPlanShare.vue?vue&type=script&lang=js"
export * from "./FinancialPlanShare.vue?vue&type=script&lang=js"
import style0 from "./FinancialPlanShare.vue?vue&type=style&index=0&id=0accf141&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0accf141",
  null
  
)

export default component.exports